export function asyncImportCode({ retries, importFunc }) {
    if (retries > 0) {
        importFunc().catch(() => {
            asyncImportCode({ retries: retries - 1, importFunc });
        });
    }
}

export default function importOnDomLoad({ importFunc }) {
    if (typeof window === 'undefined') {
        return;
    }

    window.addEventListener('load', () => {
        asyncImportCode({ retries: 3, importFunc });
    });
}
